export const googleOauthClientId =
  '369095488094-6o8md8oev71nk363mhtvedfkh8gu6h2q.apps.googleusercontent.com';
